import { useEffect, useState } from "react";
import axios from 'axios'

export default function useGeoInfo(){
    const [codeCountry,setCodeCountry] = useState(undefined)

    useEffect(() => {
        let mounted = true;
        axios.get('https://ip.nf/me.json')
        .then((response) => {
            if(mounted){
                setCodeCountry(response.data)
            }
        })
        .catch((error) => {
            setCodeCountry(null)
        });

        return () => mounted = false;
    }, [])

    return codeCountry
}